/**
 * 간단한 번역 훅 (임시)
 */

import { useState } from 'react';

// 간단한 메시지
const messages = {
  ko: {
    'generator.title': '패스워드 생성기',
    'generator.generate': '새 패스워드 생성',
    'generator.usePassword': '이 패스워드 사용',
    'generator.length': '길이',
    'generator.options': '옵션',
    'generator.includeUppercase': '대문자 포함 (A-Z)',
    'generator.includeLowercase': '소문자 포함 (a-z)',
    'generator.includeNumbers': '숫자 포함 (0-9)',
    'generator.includeSpecialChars': '특수문자 포함 (!@#$...)',
    'generator.includeSymbols': '추가 기호 포함 (~`...)',
    'generator.excludeSimilar': '유사한 문자 제외 (il1Lo0O)',
    'generator.excludeAmbiguous': '애매한 문자 제외 ({}[]())',
    'generator.noConsecutive': '연속된 같은 문자 방지',
    'generator.pronounceable': '발음 가능한 패스워드',
    'generator.excludeChars': '제외할 문자들',
    'generator.excludeCharsPlaceholder': '제외하고 싶은 문자를 입력하세요',
    'generator.noValidChars': '⚠️ 사용 가능한 문자가 없습니다. 옵션을 확인해주세요.',
    'strength.onlineAttack': '온라인 공격 시간',
    'strength.offlineAttack': '오프라인 공격 시간',
    'strength.guessCount': '추측 횟수',
    'strength.recommendations': '개선 권장사항',
    'strength.lengthRecommendation': '최소 {length}자 이상 사용하는 것을 권장합니다.',
    'strength.addUppercase': '대문자를 포함해보세요.',
    'strength.addLowercase': '소문자를 포함해보세요.',
    'strength.addNumbers': '숫자를 포함해보세요.',
    'strength.addSpecialChars': '특수문자를 포함해보세요.'
  }
};

export function useTranslation() {
  const [language] = useState('ko');
  
  const t = (key, params = {}) => {
    let message = messages[language]?.[key] || key;
    
    // 매개변수 치환
    if (params && typeof message === 'string') {
      Object.keys(params).forEach(param => {
        message = message.replace(`{${param}}`, params[param]);
      });
    }
    
    return message;
  };
  
  return { t, language };
}